export const appId = import.meta.env.VITE_INTERCOM_APP_ID;
